import React, { useEffect, useState } from 'react';
import ProcessIndicator from '../ProcessIndicator';
import { CompanyDetailsProgresses } from 'assets/helperdata/client/company-details-progress';
import { MdKeyboardArrowRight, MdKeyboardArrowLeft } from 'react-icons/md';
import { useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { allCountriesList } from 'assets/helperdata/countries-list';

import Select from 'react-select';
import { Skeleton } from '@mui/material';
import toast from 'react-hot-toast';
import { FaSpinner } from 'react-icons/fa';
import { useLanguage } from '../../../../contexts/LanguageContext';

// ✅ Clear
const CompanyAddress = () => {
	const history = useNavigate();
	const [isInProgress, setIsInProgress] = useState(false);
	const [isPageLoading, setIsPageLoading] = useState(true);
	const clientUser = useSelector((state) => state.main.client);
	const [isCheckboxChecked, setIsCheckboxChecked] = useState(false);
	const [isMobile, setIsMobile] = useState(window.innerWidth < 768);
	const [shippingData, setShippingData] = useState({
		id: clientUser?.data?.id,
		companyAddress: '',
		city: '',
		country: '',
		zip: ''
	});
	const [billingData, setBillingData] = useState({
		id: clientUser?.data?.id,
		companyAddress: '',
		city: '',
		country: 'United Arab Emirates',
		zip: ''
	});
	const [isFormProcessing, setIsFormProcessing] = useState(false);

	useEffect(() => {
		const handleResize = () => {
			setIsMobile(window.innerWidth < 768);
		};

		window.addEventListener('resize', handleResize);
		return () => window.removeEventListener('resize', handleResize);
	}, []);

	useEffect(() => {
		if (clientUser?.data?.id) {
			api.getClientInformation(clientUser?.data?.id).then((res) => {
				setIsPageLoading(false)
				if (res.data.companyBillingAddress) {
					setBillingData({
						companyAddress: res.data.companyBillingAddress.address,
						city: res.data.companyBillingAddress.city,
						country: res.data.companyBillingAddress.country,
						zip: res.data.companyBillingAddress.zip
					});
				}
				if (res.data.companyShippingAddress) {
					setShippingData({
						companyAddress: res.data.companyShippingAddress.address,
						city: res.data.companyShippingAddress.city,
						country: res.data.companyShippingAddress.country,
						zip: res.data.companyShippingAddress.zip
					});
				}
			});
		}
	}, [clientUser?.data?.id]);

	const moveToNext = () => {
		if (billingData.companyAddress == '' || billingData.city == '' || billingData.country == '' || billingData.zip == '') {
			toast.error('Please fill all fields');
			setIsInProgress(false);
			setIsFormProcessing(false)
			return;
		}

		let data = {
			id: clientUser?.data?.id,
			billingData: { ...billingData }
		};

		if (isCheckboxChecked) {
			if (shippingData.companyAddress == '' || shippingData.city == '' || shippingData.country == '' || shippingData.zip == '') {
				toast.error('Please fill all fields');
				setIsFormProcessing(false);
				setIsInProgress(false);
				return;
			}
			data.shippingData = { ...shippingData };
		}

		setIsFormProcessing(true)
		api
			.updateClientAddress(data.id, data)
			.then((res) => {
				setIsFormProcessing(false)
				setIsInProgress(false);
				if (res.message === 'Client updated successfully') {
					toast.success('Company Address Updated Successfully');
					history('/client/company-documents');
				} else {
					toast.error(res.message);
				}
			})
			.catch((err) => {
				setIsInProgress(false);
				setIsFormProcessing(false)
				console.log(err);
				setIsInProgress(false);
			});
	};
	const moveToBack = () => {
		setIsInProgress(false);
		history('/client/company-details');
	};
	const handleCheckboxChange = (e) => {
		setIsCheckboxChecked(e.target.checked);
	};

	const calculateCompletionPercentage = () => {
		const fields = ['companyAddress', 'city', 'country', 'zip'];
		const filledFields = fields.filter((field) => billingData[field] !== '');
		return (filledFields.length / fields.length) * 100;
	};

	// Call this function whenever you want to get the completion percentage
	const completionPercentage = calculateCompletionPercentage();

	const { t } = useLanguage()

	return (
		<div className={`main-page-client ${isMobile ? 'padding-mobile-client' : ''}`}>
			<div className="actions-company-details-client">
				<ProcessIndicator
					isInProgress={isInProgress}
					processes={CompanyDetailsProgresses}
					currentIndex={2}
					completionPercentage={completionPercentage}
				/>
			</div>
			<div className="company-details-client-content">
				<div className="" style={{ justifyContent: 'space-between' }}>
					<table className="projectmix-table-vertical-client">
						<tbody>
							<tr>
								{!isMobile && <th></th>}
								<td className="fw-600" style={{ textAlign: isMobile ? 'left' : 'left', fontSize: isMobile ? 16 : 14 }}>
									{t('billing-address.billing-address')}
								</td>
							</tr>
							<tr>
								{
									!isMobile && (
										<th>
											{
												isPageLoading ? (
													<div>
														<Skeleton variant="rounded" width="90%" height={30} style={{ borderRadius: '32px' }} />
													</div>
												) : (
													t('billing-address.address')
												)
											}
										</th>
									)
								}
								<td>
									{
										isMobile && (
											isPageLoading ? (
												<div style={{ width: '150px' }}>
													<Skeleton variant="rounded" width="100%" height={30} style={{ borderRadius: '32px' }} />
												</div>
											) : (
												<label className="onboard-label">{t('billing-address.address')}</label>
											)
										)
									}
									{
										isPageLoading ? (
											<div style={{ padding: '4px 0'}}>
												<Skeleton variant="rounded" width="100%" height={30} style={{ borderRadius: '32px' }} />
											</div>
										) : (
											<input
												type="text"
												className="form-control"
												value={billingData?.companyAddress}
												onChange={(e) => {
													setBillingData({ ...billingData, companyAddress: e.target.value });
													const completionPercentage = calculateCompletionPercentage();
												}}
											/>
										)
									}
								</td>
							</tr>
							<tr>
								{
									!isMobile && (
										<th>
											{
												isPageLoading ? (
													<div>
														<Skeleton variant="rounded" width="90%" height={30} style={{ borderRadius: '32px' }} />
													</div>
												) : (
													t('billing-address.city')
												)
											}
										</th>
									)
								}
								<td>
									{
										isMobile && (
											isPageLoading ? (
												<div style={{ width: '150px' }}>
													<Skeleton variant="rounded" width="100%" height={30} style={{ borderRadius: '32px' }} />
												</div>
											) : (
												<label className="onboard-label">{t('billing-address.city')}</label>
											)
										)
									}
									{
										isPageLoading ? (
											<div style={{ padding: '4px 0'}}>
												<Skeleton variant="rounded" width="100%" height={30} style={{ borderRadius: '32px' }} />
											</div>
										) : (
											<input
												type="text"
												className="form-control"
												value={billingData?.city}
												onChange={(e) => {
													setBillingData({ ...billingData, city: e.target.value });
													const completionPercentage = calculateCompletionPercentage();
												}}
											/>
										)
									}
								</td>
							</tr>
							<tr>
								{
									!isMobile && (
										<th>
											{
												isPageLoading ? (
													<div>
														<Skeleton variant="rounded" width="90%" height={30} style={{ borderRadius: '32px' }} />
													</div>
												) : (
													t('billing-address.country')
												)
											}
										</th>
									)
								}
								<td>
									{
										isMobile && (
											isPageLoading ? (
												<div style={{ width: '150px' }}>
													<Skeleton variant="rounded" width="100%" height={30} style={{ borderRadius: '32px' }} />
												</div>
											) : (
												<label className="onboard-label">{t('billing-address.country')}</label>
											)
										)
									}
									{
										isPageLoading ? (
											<div style={{ padding: '4px 0'}}>
												<Skeleton variant="rounded" width="100%" height={30} style={{ borderRadius: '32px' }} />
											</div>
										) : (
											<Select
												className="rs-container-est-white-client"
												classNamePrefix="rs"
												isSearchable={true}
												name="customer"
												options={allCountriesList?.map((y) => ({ label: y.name, value: y.name }))}
												value={allCountriesList?.map((y) => ({ label: y.name, value: y.name }))?.find((y) => y?.value == billingData?.country)}
												onChange={(e) => {
													setBillingData({ ...billingData, country: e.value });
													const completionPercentage = calculateCompletionPercentage();
												}}
												menuPlacement="auto"
												menuPosition="fixed"
											/>
										)
									}
								</td>
							</tr>
							<tr>
								{
									!isMobile && (
										<th>
											{
												isPageLoading ? (
													<div>
														<Skeleton variant="rounded" width="90%" height={30} style={{ borderRadius: '32px' }} />
													</div>
												) : (
													t('billing-address.zip-code')
												)
											}
										</th>
									)
								}
								<td>
									{
										isMobile && (
											isPageLoading ? (
												<div style={{ width: '150px' }}>
													<Skeleton variant="rounded" width="100%" height={30} style={{ borderRadius: '32px' }} />
												</div>
											) : (
												<label className="onboard-label">{t('billing-address.zip-code')}</label>
											)
										)
									}
									{
										isPageLoading ? (
											<div style={{ padding: '4px 0'}}>
												<Skeleton variant="rounded" width="100%" height={30} style={{ borderRadius: '32px' }} />
											</div>
										) : (
											<input
												type="text"
												className="form-control"
												value={billingData?.zip}
												onChange={(e) => {
													setBillingData({ ...billingData, zip: e.target.value });
													const completionPercentage = calculateCompletionPercentage();
												}}
											/>
										)
									}
								</td>
							</tr>
						</tbody>
					</table>
					<div className="group-chk-cmpny-dtls">
						{
							isPageLoading ? (
								<div style={{ width: '200px',padding: '4px 0', marginTop: '-10px'}}>
									<Skeleton variant="rounded" width="100%" height={30} style={{ borderRadius: '32px' }} />
								</div>
							) : (
								<>
									<label className="client-page-checkbox">
										<input type="checkbox" name="" id="" onChange={handleCheckboxChange} />
										<span className="checkmark"></span>
									</label>
									<label htmlFor="">{t('billing-address.different-shipping-address')}</label>
								</>
							)
						}
					</div>
					{isCheckboxChecked && (
						<table className="projectmix-table-vertical-client">
							<tbody>
								<tr>
									{!isMobile && <th></th>}
									<td className="fw-600" style={{ textAlign: isMobile ? 'left' : 'left', fontSize: isMobile ? 16 : 14 }}>
										{t('billing-address.shipping-address')}
									</td>
								</tr>
								<tr>
									{!isMobile && <th>{t('billing-address.address')}</th>}
									<td>
										{isMobile && <label className="onboard-label">{t('billing-address.address')}</label>}
										<input
											type="text"
											className="form-control"
											value={shippingData?.companyAddress}
											onChange={(e) => {
												setShippingData({ ...shippingData, companyAddress: e.target.value });
											}}
										/>
									</td>
								</tr>
								<tr>
									{!isMobile && <th>{t('billing-address.city')}</th>}
									<td>
										{isMobile && <label className="onboard-label">{t('billing-address.city')}</label>}
										<input
											type="text"
											className="form-control"
											value={shippingData?.city}
											onChange={(e) => {
												setShippingData({ ...shippingData, city: e.target.value });
											}}
										/>
									</td>
								</tr>
								<tr>
									{!isMobile && <th>{t('billing-address.country')}</th>}
									<td>
										{isMobile && <label className="onboard-label">{t('billing-address.country')}</label>}
										<Select
											className="rs-container-est-white-client"
											classNamePrefix="rs"
											isSearchable={true}
											name="customer"
											options={allCountriesList?.map((y) => ({ label: y.name, value: y.name }))}
											value={allCountriesList
												?.map((y) => ({ label: y.name, value: y.name }))
												?.find((y) => y?.value == shippingData?.country)}
											onChange={(e) => {
												setShippingData({ ...shippingData, country: e.value });
											}}
											menuPlacement="auto"
											menuPosition="fixed"
										/>
									</td>
								</tr>
								<tr>
									{!isMobile && <th>{t('billing-address.zip-code')}</th>}
									<td>
										{isMobile && <label className="onboard-label">{t('billing-address.zip-code')}</label>}
										<input
											type="text"
											className="form-control"
											value={shippingData?.zip}
											onChange={(e) => {
												setShippingData({ ...shippingData, zip: e.target.value });
											}}
										/>
									</td>
								</tr>
							</tbody>
						</table>
					)}
				</div>
			</div>
			<div className="action-company-dtls-adrs-btn" style={{ marginTop: 10 }}>
				{
					isPageLoading ? (
						<div style={{ width: '102px' }}>
							<Skeleton variant="rounded" width="100%" height={35} style={{ borderRadius: '6' }} />
						</div>
					) : (
						<button
							className="btn btn-cmpny-dtls-action-back"
							onClick={() => {
								setIsInProgress(true);
								moveToBack();
							}}
						>
							<MdKeyboardArrowLeft /> {t('billing-address.back')}
						</button>
					)
				}
				{
					isPageLoading ? (
						<div style={{ width: '102px' }}>
							<Skeleton variant="rounded" width="100%" height={35} style={{ borderRadius: '6' }} />
						</div>
					) : (
						<button
							className={`btn btn-cmpny-dtls-action ${isFormProcessing ? 'disabled' : ''}`}
							disabled={isFormProcessing}
							onClick={() => {
								if (isFormProcessing) return;
								setIsFormProcessing(true)
								setIsInProgress(true);
								moveToNext();
							}}
						>
							{
								isFormProcessing ? (
									<div><FaSpinner className='spinner' style={{ height: '18px' }} /> <span style={{ marginLeft: '-7px' }}>Please wait...</span></div>
								) : (
									<>
										{t('billing-address.next')} <MdKeyboardArrowRight />
									</>
								)
							}
						</button>
					)
				}
			</div>
		</div>
	);
};

export default CompanyAddress;
